import { RRule } from "rrule";

export enum sessionStorageKeys {
  passwordResetToken = "passwordResetToken",
  verifyEmailToken = "verifyEmailToken",
}

export const ARE_YOU_SURE_TYPES = {
  settingDomainMultiDelete: "settingDomainMultiDelete",
  assessmentTemplateDelete: "assessmentTemplateDelete",
};

export enum ExceptionTypes {
  InvalidEmail = "exc_invalid_email",
  ChecklistRequestedFetchFailed = "exc_checklist_requested_fetch_failed",
  OidCookieNotPresent = "exc_oid_cookie_not_found",
  OrgPlanNotEntitled = "exc_org_plan_not_entitled",
  InvalidSession = "exc_session_invalid",
  LoginException = "exc_auth_perm-2",
  ProfileUpdateFailed = "exc_profile_update_fail",
  excIdNotExistNotAccessible = "exc_id_not_exist_not_accessible",
  excChecklistRequestedUpdateFailed = "exc_checklist_requested_update_failed",
  ChecklistRequestedEmailVerifyFailed = "exc_checklist_requested_email_verify_failed",
  FileDoesNotExistsInS3Bucket = "exc_file_does_not_exists_in_s3_bucket",
  ReadFail = "exc_read_fail-1",
  DeleteFail = "exc_delete_fail",
  UserPasswordChangeFail = "exc_user_password_change_fail",
  UserMFAEnableFail = "exc_user_mfa_enable_fail-1",
  UserMFAVerifyFail = "exc_user_mfa_verify_fail",
  MinimumRequiredOptionalInputsMissing = "exc_minimum_required_optional_inputs_missing",
  UserAuthWebauthnMissingReferer = "exc_user_auth_webauthn_missing_referer",

  //Invite
  DomainRestricted = "exc_domain_restricted",
  OrgAccessRequestOwnDomainNotAllowed = "exc_org_access_request_own_domain_not_allowed",
  OrgAccessRequestVerifiedDomainsNotAllowed = "exc_org_access_request_verified_domains_not_allowed",
  InvalidParameters = "exc_invalid_parameters-1",
  SystemActionsReadError = "exc_system_actions_read_error",
  OrgToOrgTypeNotLockable = "exc_org_to_org_type_not_lockable",
  OrgAccessRequestError = "exc_org_access_request_error",
  OrgAccessOfferOwnDomainsNotAllowed = "exc_org_access_offer_own_domains_not_allowed",
  OrgAccessOfferVerifiedDomainsNotAllowed = "exc_org_access_offer_verified_domains_not_allowed",
  OrgAccessOfferUnauthorisedToOfferRole = "exc_org_access_offer_unauthorised_to_offer_role",
  OrgAccessRequestProcessUnauthorizedToProcess = "exc_org_access_request_process_unauthorized_to_process",
  InvalidRoleId = "exc_invalid_role_id",
  RoleMembersInvalid = "exc_role_members_invalid",
  RoleLastForCurrentUserInThisOrg = "exc_role_last_for_current_user_in_this_org",
  OrgAccessRequestInvalid = "exc_org_access_request_invalid",
  OrgAccessOfferInvalid = "exc_org_access_offer_invalid",
  OrgAccessOfferExpired = "exc_org_access_offer_expired",
  GetPermissionLevelValueFromCachedDataByKeyFail = "exc_get_permission_level_value_from_cached_data_by_key_fail",
  //Org
  InvalidDomain = "exc_invalid_domain",
  InvalidTLD = "exc_invalid_tld",
  OrgSwitchPlanNotEntitled = "exc_org_switch_plan_not_entitled",
  OrgSwitchFailed = "exc_org_switch_failed",
  FileUploadToS3Failed = "exc_file_upload_to_s3_failed",
  OrgToProfileImageUpdateFailed = "exc_org_to_profile_image_update_failed",
  OrgToProfileImageCreateFailed = "exc_org_to_profile_image_create_failed",
  UserEmailAlreadyExists = "exc_user_email_already_exists",
  InvalidSalutationId = "exc_invalid_salutation_id",
  UserCreationFailed = "exc_user_creation_failed",
  UserDeactivated = "exc_user_deactivated",
  UserCannotDeleteThemselves = "exc_user_cannot_delete_themselves",
  RoleContainsMembers = "exc_role_contains_members",
  OrgNameCodeAlreadyExists = "exc_org_name_code_already_exists",
  UpdateFail = "exc_update_fail",
  RoleNameInvalid = "exc_role_name_invalid",
  RoleNameAlreadyExists = "exc_role_name_already_exists",
  RoleTypeInvalid = "exc_role_type_invalid",
  UserNotAssociatedWithCurrentOrg = "exc_user_not_associated_with_current_org",
  UserPasswordResetFailed = "exc_user_password_reset_failed",
  OrgMemberAlreadyDeactivated = "exc_org_member_already_deactivated",
  UserNotAnInternalMemberOfCurrentOrg = "exc_user_not_an_internal_member_of_current_org",
  OrgMemberLastInRole = "exc_org_member_last_in_role",
  UserCannotDeactivateThemselves = "exc_user_cannot_deactivate_themselves",
  OrgMemberDeactivationFail = "exc_org_member_deactivation_fail",
  UserNotAnExternalMemberOfCurrentOrg = "exc_user_not_an_external_member_of_current_org",
  UserHasNoRoleMembershipsInThisOrg = "exc_user_has_no_role_memberships_in_this_org",
  UserIdInvalid = "exc_user_id_invalid",
  OrgMemberAlreadyArchived = "exc_org_member_already_archived",
  OrgMemberDeletionFail = "exc_org_member_deletion_fail",
  EmailDomainNotRegistered = "exc_email_domain_not_registered",
  OrgAlreadyExists = "exc_org_already_exists",
  OrgProfileImageNotProvided = "exc_org_profile_image_not_provided",
  InvalidOrgId = "exc_invalid_org_id",
  OrgFetchFailed = "exc_org_fetch_failed",
  UserCannotRevokeOwnHomeOrgAccess = "exc_user_cannot_revoke_own_home_org_access",
  UserLastRoleMemberForOrg = "exc_user_last_role_member_for_org",
  OrgDomainRetrivalFailed = "exc_org_domain_retrival_failed",
  SOARecordNotExist = "exc_soa_record_not_exists",
  InvalidParent = "exc_invalid_parent",
  OrgDomainAlreadyExist = "exc_org_domain_already_exists",
  OrgDomainAddFailed = "exc_org_domain_add_failed",
  ItemIsParent = "exc_item_is_parent",
  InvalidOrgDomainId = "exc_invalid_org_domainid",
  OrgDomainVerifyEmailDomainMismatch = "exc_org_domain_verify_email_domain_mismatch",
  OrgDomainAlreadyVerifiedEmail = "exc_org_domain_already_verified_email",
  CreateRequestOrgDomainAlreadyExists = "exc_org_verify_domain_already_exists",
  CreateRequestOrgDuplicateRecord = "exc_duplicate_record-1",
  OrgDomainUnableToDeleteInUse = "exc_org_domain_unable_to_delete_in_use",
  OrgDomainRecordNotFound = "exc_org_domain_record_not_found",
  OrgDomainUpdateFailed = "exc_org_domain_update_failed",
  DomainRegistrarIdInvalid = "exc_domain_registrar_id_invalid",
  OrgDomainNameUnupdatable = "exc_org_domain_name_unupdatable",
  OrgDomainNotVerifiedEmail = "exc_org_domain_not_verified_email",
  InvalidRecordId = "exc_invalid_record_id",
  RecordAlreadyExists = "exc_record_already_exists",
  OrgMemberIsLocked = "exc_org_member_is_locked",
  EmailDomainNotVerified = "exc_email_domain_not_verified",
  RequiredIncidents = "exc_mandatory_input_properties_missing",
  UserCannotUndeleteThemselves = "exc_user_cannot_undelete_themselves",
  OrgMemberIsNotArchived = "exc_org_member_is_not_archived",
  OrgDomainIsNotVerified = "exc_org_domain_is_not_verified",

  //assetment
  ChecklistCreateFailed = "exc_checklist_create_failed",
  ChecklistToStatusCreateFailed = "exc_checklist_to_status_create_failed",
  ChecklistTemplateToItemMasterFetchFail = "exc_checklist_template_to_item_master_fetch_failed",
  ChecklistToItemCreateFailed = "exc_create_checklist_to_item_failed",
  ChecklistItemToCategoryCreateFailed = "exc_checklist_item_to_category_create_failed",
  ChecklistToTemplateCreateFailed = "exc_checklist_to_template_create_fail",
  ChecklistReadFail = "exc_checklist_read_fail",
  CreateFail = "exc_create_fail",
  CreateFailIncidentRecord = "exc_create_fail",
  ChecklistToItemCompletionMetricDetailsFetchFailed = "Checklist to item completion metrics fetch failed",
  ChecklistCategoriesFetchFailed = "exc_checklist_categories_fetch_fail",
  ChecklistIdInvalidForTheCurrentOrg = "exc_checklist_id_invalid_for_the_current_org",
  ChecklistCategoryIdInvalidForTheCurrentOrg = "exc_checklist_category_id_invalid_for_the_current_org",
  ChecklistTemplateInvalidId = "exc_checklist_template_invalid_id",
  ChecklistTemplatePlanNotEntitled = "exc_checklist_template_plan_not_entitled",
  ChecklistInvalidId = "exc_checklist_invalid_id",
  ChecklistReportDataFetchFailed = "exc_checklist_report_data_fetch_failed",
  ChecklistToItemMetricDetailFetchFailed = "exc_checklist_to_item_Metric_detail_fetch_failed",
  ChecklistToItemMetricGradeDetailFetchFailed = "exc_checklist_to_item_metric_grade_detail_fetch_failed",
  ChecklistToItemRefreshAllowedOnlyForNotCompletedState = "exc_checklist_to_item_refresh_allowed_only_for_not_completed_state",
  ChecklistToItemInputValidationFailed = "exc_checklist_to_item_input_validation_failed",
  ChecklistItemGroupDetailFetchFailed = "exc_checklist_item_group_detail_fetch_fail",
  ChecklistForecastInvalidId = "exc_checklist_forecast_invalid_id",
  ChecklistToTemplateNoItems = "exc_checklist_to_template_no_items",
  ChecklistTemplateAlreadyExists = "exc_checklist_template_already_exists",
  ChecklistUpdateFailedWrongStatus = "exc_checklist_update_failed_wrong_status",
  ChecklistToItemPerTypeDuplicationFetchFail = "exc_checklist_to_item_per_type_duplication_fetch_fail",
  NotAssociatedWithCurrentOrg = "exc_not_associated_with_current_org",
  ChecklistItemGroupInvalidId = "exc_checklist_item_group_invalid_id",
  InvalidGroupMainId = "exc_invalid_group_main_id",
  FileClamScanFailed = "exc_file_clam_scan_failed",
  ChecklistItemGroupActionIsNotArchived = "exc_checklist_item_group_action_is_not_archived",
  ChecklistToItemIdIsExcluded = "exc_checklist_to_item_id_is_excluded",
  //checklist

  //scanning
  ScanReportRunScheduleInvalidIds = "exc_scan_report_run_schedule_invalid_ids",
  ScanReportRunScheduleAlreadyExists = "exc_scan_report_run_schedule_already_exists",
  ScanReportRunScheduleDuplicateIds = "exc_scan_report_run_schedule_duplicate_ids",
  ScanReportRunScheduleDoesNotExist = "exc_scan_report_run_schedule_does_not_exist",
  ScanReportRunScheduleUpdateWebservicesFail = "exc_scan_report_run_schedule_update_webservices_fail",
  ScanReportRunScheduleUpdateFail = "exc_scan_report_run_schedule_update_fail",
  ChecklistTemplateNotOwnedByCurrentOrg = "exc_checklist_template_not_owned_by_current_org",
  ScansSummaryFail = "exc_scans_summary_fail",
  ScanGetReportCSVFail = "exc_scan_get_report_csv_fail",

  //recommendation
  InvalidForecastDate = "exc_invalid_forecast_date",
  ChecklistItemForecastInvalidGroupId = "exc_checklist_item_forecast_invalid_group_id",
  ChecklistToCategoryInfoUpsertFailed = "exc_checklist_to_category_info_upsert_failed",
  UserUnauthorized = "exc_user_unauthorized",

  //vendor
  ChecklistRequestedCreateFailed = "exc_checklist_requested_create_failed",
  ChecklistTemplateReadFail = "exc_checklist_template_read_fail",
  ChecklistRequestedInvalidExpiryDate = "exc_checklist_requested_invalid_expiry_date",
  ChecklistRequestedEmailGrantFailed = "exc_checklist_requested_email_grant_failed",
  ChecklistRequestedEmailGrantNotWithinDates = "exc_checklist_requested_email_grant_not_within_dates",
  ChecklistTemplateNoItems = "exc_checklist_template_no_items",

  //other
  generic_exception = "Generic Exception",

  //domains
  domainVerifyCannotUpdate = "exc_org_domain_verify_cannot_update",
}

export const langLocale = {
  en: "en",
  fre: "fr",
  ch: "zh_cn",
};

export const infomationRequiredId = 80;

export const CLR_REVIEW_OPTION = {
  notAccepted: 79,
  accepted: 81,
  resetReview: null,
};

export enum ModalTypes {
  CreateOrg = "create-org",
}
export enum exceptionStatusCodes {
  Unauthorized = 401, // move to login
  Forbidden = 403, // show toast
  UnprocessableEntity = 422, // do nothing
  InternalServerError = 500, // show toast
  BadRequest = 400, // do nothing
  NotFoundRequest = 404, // show toast
  BadGateway = 502, // show toast
}

export enum successStatusCodes {
  "OK" = 200,
}
export enum typeCurrentScan {
  domain = "Domain",
  webService = "Web service",
}

export const whiteListCSRF = [
  "/prospect/prospect-verify-not-recapcha",
  "/user/password/reset/callback",
  "/user/verify/email/callback",
] as string[];

export const INIT_NUMBER_SHOW_QUESTION = 10;
export const NUMBER_LOADMORE_QUESTION = 15;

export const headerCsrf = "XSRF-TOKEN";
export const url =
  process.env["VUE_APP_API_URL"] || "http://localhost:3002/api/v1";
export const urlApp = process.env["VUE_APP_URL"] || "http://localhost:8080";
export const requestTimeout = 100000;

export const manageDomainActions = {
  verify: "verify",
  delete: "delete",
  verifyLater: "verifyLater",
};

export const localStorageBoolean = {
  true: "true",
  false: "false",
};

export const requestAccessDetailModalType = {
  createOrg: "createOrg",
  createRequest: "createRequest",
  editRequest: "editRequest",
} as const;

export const actionClickType = {
  actionManageUser: "showModalManageUser",
  actionResetPassword: "showModalPassword",
  actionAddMFA: "showModalAddMFA",
  actionAddAnotherMFA: "showModalAddAnotherMFA",
  actionEnableMFA: "showModalEnableMFA",
  actionResetMFA: "showModalMFA",
  actionDeactivate: "showModalDeactivate",
  actionActive: "showModalActivate",
  actionDeleteUser: "showModalDelete",
  actionUnlockUser: "showModalUnlock",
  actionRemoveAccess: "showModalRemoveAccess",
  actionRemoveOrgAccess: "showModalRemoveOrgAccess",
  actionProcessRequest: "actionProcessRequest",
  actionProcessOffer: "actionProcessOffer",
  actionRemoveFile: "showModalRemoveFile",
  actionRemoveFormAction: "actionRemoveFormAction",
  actionShowAssessmentsAdvanced: "showModalAssessmentsAdvanced",

  actionVerifyDomain: "actionVerifyDomain",
  actionManageDomain: "actionManageDomain",
  actionDeleteDomain: "actionDeleteDomain",
  actionDownload: "actionDownload",
  actionRestoreUser: "actionRestoreUser",
  actionSendVerificationEmail: "actionSendVerificationEmail",

  actionEditActionRecomendation: "actionEditAction",
  actionDeleteActionRecomendation: "actionDeleteAction",
  actionDeleteActionQuestion: "actionDeleteActionQuestion",
  actionAddActionQuestion: "actionAddActionQuestion",
  actionMarkAsComplete: "actionMarkAsComplete",
  actionMarkAsInProgress: "actionMarkAsInProgress",
  actionMarkAsNotStarted: "actionMarkAsNotStarted",
  actionClearStatus: "actionClearStatus",
  actionMarkAsQuickWinRecomendation: "actionMarkAsQuickWin",
  actionUnVerifyDomain: "actionUnVerifyDomain",
  actionUnVerifyEmail: "actionUnVerifyEmail",
  actionResendInvite: "actionResendInvite",
};

export const DEFAULT_AVATAR_COLOR = [
  "#ffba38",
  "#ff387d",
  "#9cbeff",
  "#bd0383",
];

export const statusCode = {
  active: "active",
  pending: "pending",
  invited: "invited",
  deactivated: "deactivated",
  locked: "locked",

  inProgress: "In progress",
  completed: "Completed",
  notStarted: "Not started",
  audited: "Audited",

  critical: "Critical",

  high: "High",
  significant: "Significant",
  highest: "Highest",
  moderate: "Moderate",
  suggested: "Suggested",

  category: "Category",
  subCategory: "Sub Category",

  verify: "verify",
  pendingVerify: "pending verify",
  notVerify: "not verify",
  archived: "archived",
  applied: "Applied",
  disable: "disable",
  system: "System",
  org: "Org",
  parent: "Parent",
  required: "Required",
  accepted: "Accepted",
  informationRequired: "Information Required",
  notAccepted: "Not Accepted",
  created: "Created",
  waiting: "Waiting",
  paused: "Paused",
  other: "Other",
  complete: "Complete",
  defunct: "Defunct",
  waitingOnUs: "Waiting on Us",
  vendorSubmitted: "Submitted",
  waitingForVendor: "Waiting",
  wait: "Wait",
  inProg: "In Progress",
};

export const templateType = {
  system: "System",
  org: "org",
  parent: "parent",
};

export const routers = {
  dashboard: "/dashboard",
  assessCreate: "/assess/manage",
  assessRecommend: "/assess/roadmap",
  assessBenchmark: "/assess/benchmark",
  assessVendor: "/assess/vendor/manage",

  scanScanning: "/scan/scanning",
  scanTechassets: "/scan/techassets",

  riskDashboard: "/risk/dashboard",

  complianceAudits: "/compliance/audits",

  pentestPentests: "/pentest/pentests",

  insuranceQuestionnaires: "/insurance/questionnaires",

  shareProfile: "/reports/chr",
  shareExternal: "/share/external",

  serviceMarket: "/service/marketplace",

  learnHelp: "/learn/help",

  settingsSetup: "/settings/setup",
  settingOrgManageAccess: "/settings/organisation/access",
  settingOrgDetails: "/settings/organisation/details",
  settingOrgProfile: "/settings/organisation/profile",
  settingDomains: "/settings/domains",
  settingTeamRoles: "/settings/team/roles",
  settingTeamMembers: "/settings/team/members",
  settingSubscription: "/settings/subscription",
  assessChecklist: "/assess/input",
};

export const assessmentStatus = {
  created: "Created",
  inProgress: "In progress",
  waiting: "Waiting",
  paused: "Paused",
  other: "Other",
  notStarted: "Not Started",
  completed: "Completed",
  complete: "Complete",
  audited: "Audited",
  defunct: "Defunct",
  waitingOnUs: "Waiting on Us",
  waitingForVendor: "Waiting",
  submitted: "Submitted",
  vendorSubmitted: "Vendor submitted",
  inProg: "In Progress",
  wait: "Wait",
};

export const checklistStatusId = {
  created: "new",
  inProgress: "inprog",
  waiting: "wait",
  paused: "paus",
  other: "oth",
  completed: "done",
  defunct: "dfct",
  waitingOnUs: "wtus",
  submitted: "submit",
};

export const checklistRequestedStatusId = {
  created: "new",
  waiting: "wait",
  inProgress: "inprog",
  submitted: "submit",
  completed: "done",
  defunct: "dfct",
};

export const scanning = {
  error: "Error",
  scheduled: "Scheduled",
  complete: "Complete",
  inProgress: "In progress",
};

export const checklistStatusNotes = {
  updateFromPaused: "User updated from paused to in progress",
  updateFromCompleted: "User updated from complete to in progress",
  updateFromDefunct: "User updated from defunct to in progress",
  createScreen: "User updated from  Assessments Create screen",
  updateScreen: "User updated from  Assessments Update screen",
};

export const localStorageKey = {
  currentOrgData: "currentOrgData",
  currentUserData: "currentUserData",
  isHideComplete: "isHideComplete",
  isHideReviewedVendorInput: "isHideReviewedVendorInput",
  isHideCompleteVendorInput: "isHideCompleteVendorInput",
  showMasterItems: "showMasterItems",
  assessmentView: "assessmentView",
  assessmentActiveCategory: "assessmentActiveCategory",
  assessmentSearchTerm: "assessmentSearchTerm",
  languageId: "languageId",
  languageList: "languageList",
  languagesData: "languagesData",
  recaptcha: "recaptcha",
  isDontShowModalReOrderAction: "isDontShowModalReOrderAction",
  isOrgPlanDetails: "isOrgPlanDetails",
  forcePricingTable: "forcePricingTable",
  pwdFeIv: "pwdFeIv",
  cyberReportDisplayOption: "cyberReportDisplayOption",
  isShowExcluded: "isShowExcluded",
  isRemove: "isRemove",
  showDashboardInfo: "showDashboardInfo",
  checklistReportId: "checklistReportId",
  rootChecklistReportId: "rootChecklistReportId",
  hideSystemTemplate: "hideSystemTemplate",
  productFruitsInitialized: "productFruitsInitialized",
  vendorAssessmentReviewFilter: "vendorAssessmentReviewFilter",
  mainAssessmentFilter: "mainAssessmentFilter",
  mainAssessmentFilterId: "mainAssessmentFilterId",
  vendorManageShowArchivedAssessment: "vendorManageShowArchivedAssessment",
  vendorManageShowArchivedTemplate: "vendorManageShowArchivedTemplate",
  vendorManageIncludeHomeOrgTemplate: "vendorManageIncludeHomeOrgTemplate",
  mainSearchAssessmentFilter: "mainSearchAssessmentFilter",
  sharingPagingQuickwin: "sharingPagingQuickwin",
  sharingPagingRoadmap: "sharingPagingRoadmap",
};

export const mainSearchAssessmentFilterDefaul = [
  {
    targetId: "itemCompleteValue",
    value: {
      id: 1,
      text: "app-component-assessment-display-options-filter-hide-complete-option-B-1",
      isDefault: true,
      isHardText: false,
    },
  },
  {
    targetId: "visibleState",
    value: {
      id: 0,
      text: "app-component-assessment-display-options-filter-show-excluded-option-A-1",
      isDefault: true,
      isHardText: false,
    },
  },
];

export const assessmentAnswerType1State = {
  yes: 1,
  no: 0,
  unselected: "",
};

export const idWizardPage = {
  goalsPage: 0,
  orgsPage: 1,
  domainPage: 2,
  brandsPage: 3,
  servicesPage: 4,
  webFacingAppPage: 5,
  sitesPage: 6,
  teamsPage: 7,
  miscellaneousPage: 8,
};

export const idWizardPageIdName = [
  "goals",
  "org",
  "domains",
  "brands",
  "services",
  "webservices",
  "sites",
  "teams",
  "misc",
];

export const idTabActionTableRecommendation = {
  overview: "1",
  stepsToSolve: "2",
  makePlan: "3",
};

export const MODAL_NAME = {
  CREATE_ORG: "createOrgModal",

  ADD_DOMAIN: "addDomainModal",
  MANAGE_DOMAIN: "manageDomainModal",
  VERIFY_ADD_DOMAIN: "verifyAddDomainModal",

  VERIFY_ORG: "verifyOrgModal",

  REQUEST_ACCESS: "requestAccessModal",
  ACCEPT_REJECT_REQUEST_ACCESS: "acceptRequestAccessModal",
  OFFER_ACCESS: "offerAccessModal",
  RESEND_TOKEN_MODAL: "resendTokenModal",

  PROFILE: "profileModal",

  MEMBER_DETAIL: "memberDetailModal",

  ADD_ROLE: "addRoleModal",
  ADD_USER_ROLE: "addUserRoleModal",
  MFA_SELECTION_MODAL: "mfaSelectionModal",
  MFA_ADD_TOTP_MODAL: "mfaAddTotpModal",
  VERIFY_MODAL: "verifyModal",

  // Assessment
  MODAL_ADD_NOTE_ASSESSMENT: "addNoteAssessmentModal",
  MODAL_ASSESSMENT: "assessmentModal",
  MODAL_EVIDENCE: "modalEvidence",
  MODAL_SECURING_EVIDENCE: "modalSecuringEvidence",
  MODAL_COMPLETE_ASSESSMENT: "completeAssessmentModal",
  MODAL_UPDATE_ASSESSMENT_DETAIL: "updateAssessmentDetailModal",
  MODAL_DUPLICATE_ASSESSMENT: "duplicateAssessmentModal",
  MODAL_DUPLICATE_QUESTION: "duplicateQuestionModal",

  // Wizard
  MODAL_WIZARD_MORE_INFO: "wizardMoreInfoModal",
  MODAL_WIZARD_SAVE_EXIT: "saveAndExitModal",
  MODAL_WIZARD_DELETE: "wizardDeleteModal",
  MODAL_DOMAIN_NOT_BELONG_TO_ORG: "domainNotBelongToOrgModal",

  // Recommendation
  MODAL_RECOMMEN_ARE_YOU_SURE: "areYouSureModal",
  MODAL_IMAGE: "imageModal",
  MODAL_RECOMMENDATION_EDIT_ACTIONS: "recommendationEditActionsModal",
  MODAL_RECOMMENDATION_ADD_NEW_ACTION: "recommendationAddNewActionModal",
  MODAL_REORDER_ACTION_MODAL: "reorderActionModal",
  MODAL_SECURITY_AND_STABILITY_SCORE: "securityAndStabilityScoreModal",

  // Scanning
  MODAL_SCHEDULE: "scheduleModal",

  //Team
  MODAL_VERIFY_RESET_PASSWORD: "verifyResetPasswordModal",

  //Vendor
  MODAL_CREATE_NEW_VENDOR_ASSESSMENT: "createNewVendorAssessmentModal",
  MODAL_CREATE_VENDOR_ASSESSMENT: "CreateVendorAssessmentModal",
  MODAL_VENDOR_ASSESSMENT_ATTACHMENT: "vendorAssessmentAttachmentModal",
  MODAL_CHANGE_RECIPIENT_VENDOR_ASSESSMENT:
    "changeRecipientVendorAssessmentModal",
  MODAL_VENDOR_UPDATE_ASSESSMENT_DETAIL: "vendorUpdateAssessmentDetailModal",
  MODAL_VENDOR_EDIT_ASSESSMENT_DETAIL: "vendorEditAssessmentDetailModal",
  MODAL_MANAGE_VENDOR: "manageVendorModal",
  MODAL_MANAGE_VENDOR_DETAIL: "manageVendorDetailModal",
  MODAL_HANDLE_ANAUTH: "modalHandleAnauth",
};

export const RIGHT_SLIDE_MODAL_NAME = {
  ASSESSMENT_ADVANCED: "assessmentAdvanced",
  ASSESSMENT_REQUESTED_ADVANCED: "vendorAssessmentExternalAdvanceModal",
};

export const CHECKLIST_TYPE = {
  mainChecklist: "checklist",
  externalChecklist: "externalChecklist",
  reviewChecklist: "reviewChecklist",
};

export const statusPage = {
  CallApi: "isCallApi",
  Updating: "isUpdating",
  Error: "isError",
  Success: "isSuccess",
  NotChange: "isNotChange",
};

export const VALUE_SORT_COLUMN_ACTION_MODAL = {
  riskReduction: "riskReduction",
  scoreIncreaseTotal: "scoreIncreaseTotal",
  completionDate: "completionDate",
};

export enum assessmentAdditionalInfoType {
  note = "note",
  attachment = "attachment",
  notes = "notes",
}

export const FILTER_MODAL_TYPE = {
  mainChecklist: "mainChecklist",
};

export const orderChecklistValue = {
  z: 0,
  l: 1,
  m: 2,
  h: 3,
  vh: 4,
};

export enum assessmentQuestionVisibleState {
  yes = "Yes",
  no = "No",
  prefilled = "Prefilled",
}

export const mainAssessmentFilterDefaul = [
  {
    targetId: "itemCompleteValue",
    value: {
      id: 1,
      text: "app-component-assessment-display-options-filter-hide-complete-option-A-1",
      isDefault: true,
      isHardText: false,
    },
  },
  {
    targetId: "visibleState",
    value: {
      id: 0,
      text: "app-component-assessment-display-options-filter-show-excluded-option-A-1",
      isDefault: true,
      isHardText: false,
    },
  },
  {
    targetId: "isMaster",
    value: {
      id: 0,
      text: "app-component-assessment-display-options-filter-show-master-items-option-A-1",
      isDefault: true,
      isHardText: false,
    },
  },
];

export enum assessmentQuestionAnswerValue {
  no = "No",
  yes = "Yes",
  exists = "Exists",
  sufficient = "Sufficient",
  disclosed = "Disclosed",
  accepted = "Accepted",
  explained = "Explained",
}

export enum assessmentQuestionAnswerType {
  radio = "Radio",
  select = "Select",
}

export enum ASSESSMENT_ANSWER_ANOTHER_VALE {
  ZERO = "z",
  LOW = "l",
  MEDIUM = "m",
  HIGH = "h",
  VERY_HIGH = "vh",
  NaN = "na",
}

export enum ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE {
  ZERO = "zero",
  LOW = "low",
  MEDIUM = "med",
  HIGH = "high",
  VERY_HIGH = "vhigh",
  NaN = "na",
}

export enum ASSESSMENT_QUESTION_TYPE {
  YES_NO = "yn",
  TRUE_FALSE = "tf",
  PROVIDER = "provided",
  ATTACH = "attach",
  TEXT = "text",
}

export enum ASSESSMENT_QUESTION_TYPE_FILTER_LABE {
  tf = "app-assess-vendor-review-filter-target-question-type-yes-no-1",
  text = "app-assess-vendor-review-filter-target-question-type-text-only-1",
  attach = "app-assess-vendor-review-filter-target-question-type-attachment-required-1",
}

export enum MFAStatus {
  NOT_REQUIRED = "MFA_NOT_REQUIRED",
  REGISTERED = "MFA_REGISTERED",
  NOT_REGISTERED = "MFA_NOT_REGISTERED",
  REGISTERED_PK = "MFA_REGISTERED_PK",
  REGISTERED_PKONLY = "MFA_REGISTERED_PKONLY",
}

export enum OVERLAY_KEYBOARD {
  DROPDOWN = "DROPDOWN",
  MODAL = "MODAL",
}

export enum ASSESSMENT_ANSWER_STORE_TYPE {
  COMPLIANCE_TYPE_VALUE = "checklistItemComplianceTypeValueId",
  COMPLIANCE_OVERRIDE = "checklistItemComplianceOverride",
  COMPENSATING_CONTROL = "checklistItemCompensatingControlValue",
  NOTES = "checklistItemNotes",
  EXCLUDE_ITEM = "excludeItem",
  CHECKLIST_ITEM_ATTACHMENTS = "checklistItemAttachments",
  CHECKLIST_ITEM_IMPORTANCE = "checklistItemImportanceId",
  CHECKLIST_ITEM_IMPACT = "checklistItemImpactId",
  CHECKLIST_ITEM_COST = "checklistItemCostId",
  CHECKLIST_ITEM_EFFORT = "checklistItemEffortId",
  CHECKLIST_ITEM_DESCRIPTION = "checklistItemDescription",
}
export const CHECKLIST_ICON_VALUE_WITH_COLOR = {
  [ASSESSMENT_ANSWER_ANOTHER_VALE.ZERO]: "tw-text-[#48A0FF]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.LOW]: "tw-text-[#57B755]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.MEDIUM]: "tw-text-[#904BD6]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.HIGH]: "tw-text-[#F99A06]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.VERY_HIGH]: "tw-text-[#F7553C]",
};
export const CHECKLIST_ICON_VALUE_WITH_COLOR_IMPORTANT = {
  [ASSESSMENT_ANSWER_ANOTHER_VALE.ZERO]: "!tw-text-[#48A0FF]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.LOW]: "!tw-text-[#57B755]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.MEDIUM]: "!tw-text-[#904BD6]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.HIGH]: "!tw-text-[#F99A06]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.VERY_HIGH]: "!tw-text-[#F7553C]",
};
export const CHECKLIST_IMPACT_VALUE_WITH_COLOR = {
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.ZERO]: "tw-text-[#48A0FF]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.LOW]: "tw-text-[#57B755]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.MEDIUM]: "tw-text-[#904BD6]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.HIGH]: "tw-text-[#F99A06]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.VERY_HIGH]: "tw-text-[#F7553C]",
};
export const CHECKLIST_ICON_VALUE_WITH_BG_COLOR = {
  [ASSESSMENT_ANSWER_ANOTHER_VALE.ZERO]: "tw-bg-[rgba(72,160,255,0.15)]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.LOW]: "tw-bg-[rgba(87,183,85,0.15)]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.MEDIUM]: "tw-bg-[rgba(144,75,214,0.15)]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.HIGH]: "tw-bg-[rgba(249,154,6,0.15)]",
  [ASSESSMENT_ANSWER_ANOTHER_VALE.VERY_HIGH]: "tw-bg-[rgba(247,85,60,0.15)]",
};

export const CHECKLIST_IMPACT_VALUE_WITH_BG_COLOR = {
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.ZERO]:
    "tw-bg-[rgba(72,160,255,0.15)]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.LOW]: "tw-bg-[rgba(87,183,85,0.15)]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.MEDIUM]:
    "tw-bg-[rgba(144,75,214,0.15)]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.HIGH]: "tw-bg-[rgba(249,154,6,0.15)]",
  [ASSESSMENT_IMPACT_ANSWER_ANOTHER_VALUE.VERY_HIGH]:
    "tw-bg-[rgba(247,85,60,0.15)]",
};

export const INPUT_TYPE = {
  Dropdown: "Dropdown",
  Text: "text",
  TextArea: "TextArea",
  Number: "Number",
  Date: "Date",
  number: "number",
};

export const VENDOR_QUESTION_RENDER_TYPE = {
  heading: "heading",
  question: "question",
};

export const assessmentViews = {
  default: "default",
  list: "list",
};
export const WIZARD_ADD_ANOTHER_STATE = {
  DEFAULT_STATE: "default-state",
  WHITE_STATE: "white-state",
};

export enum wizardQuestionAnswerType {
  radio = "Radio",
  select = "Select",
}
export enum CHECKLISTSTATUS {
  NEW = "new",
  INPROG = "inprog",
  DONE = "done",
  WAIT = "wait",
  PAUS = "paus",
  OTH = "oth",
  NOT_STARTED = "notStarted",
  IN_PROGRESS = "inProgress",
  COMPLETED = "completed",
  ONHOLD = "onHold",
  DEFUNCT = "dfct",
  CREATED = "Created",
  SUBMIT = "submit",
  SUBMITTED = "submitted",
}

export enum DROPDOWN_TYPE {
  SINGLE = "single",
  MULTIPLE = "multiple",
}

export const WIZARD_STATE_NAME = {
  BRANDS: "brands",
  DOMAINS: "domains",
  GOALS: "goals",
  MISC: "misc",
  ORG: "org",
  SERVICES: "services",
  SITES: "sites",
  TEAMS: "teams",
  WEBSERVICES: "webservices",
};

export const WIZARD_STATE_NAME_FROM_ID = {
  0: "goals",
  1: "org",
  2: "domains",
  3: "brands",
  4: "services",
  5: "webservices",
  6: "sites",
  7: "teams",
  8: "misc",
};

export const WIZARD_STATE_QUESTION_TYPE_ID = {
  [WIZARD_STATE_NAME.GOALS]: {
    CONCERN: "concern",
    FEATURE: "feature",
    GOAL: "goal",
  },
  [WIZARD_STATE_NAME.SERVICES]: {
    SERVICE_TYPE: "service_type",
    SERVICE_SUB_TYPE: "service_sub_type",
    SERVICE_COMPONENT_TYPE: "service_component_type",
    SERVICE_MODEL_TYPE: "service_model_type",
  },

  WEBSERVICE_WEB: "web",
  WEBSERVICE_WEB_NAT: "web-nat",

  CONCERN: "concern",
  FEATURE: "feature",
  GOAL: "goal",
  LIFECYCLE: "lifecycle",
  INDUSTRY: "industry",
  MARKET: "market",
  REVENUE: "revenue",

  SERVICE_TYPE: "service_type",
  SERVICE_SUB_TYPE: "service_sub_type",
  SERVICE_COMPONENT_TYPE: "service_component_type",
  SERVICE_MODEL_TYPE: "service_model_type",

  PERSONAL_IDENTIFYING_INFORMATION: "pii",
  PROTECTED_HEALTH_INFORMATION: "phi",
};

export const WIZARD_STATE_SITES_TYPE_ID = {
  SITE_TYPE: "site_type",
  SITE_ATTRIBUTE_TYPE: "site_attribute_type",
  SITE_LEGAL_TYPE: "site_legal_type",
};
export const API_STATUS_LOADING = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  NO_ACTION: "NO_ACTION",
};

export const WIZARD_STATE_PAGE = {
  GOALS: "goals",
  DOMAINS: "domains",
  BRANDS: "brands",
  SERVICES: "services",
  ORG: "org",
  MISC: "misc",
  TEAMS: "teams",
  FINISH: "finish",
  SITES: "sites",
  WEBSERVICES: "webservices",
  WEBSITE: "web-site",
  WEBNAT: "web-nat",
  WEB: "web",
};

export const API_STATUS = {
  FETCHING: "FETCHING",
  HAS_DATA: "HAS_DATA",
  NO_DATA: "NO_DATA",
  NO_ACTION: "NO_ACTION",
};

export const SCAN_ITEM_STATUS_ID = {
  OK: "ok",
  PART: "part",
  NOT_COMPLIANCE: "no",
  NOT_AVAILABLE: "nav",
  NOT_APPLICABLE: "nap",
};

export const ACCEPTABLE_FILE_TYPE = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/svg+xml",
  "image/tiff",
  "image/webp",
  "image/bmp",
  "application/pdf",
  "application/rtf",
  "text/plain",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.visio",
  "text/csv",
  "video/mp4",
  "video/mpeg",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.text",
  "video/webm",
];

export const ACCEPTABLE_AVATAR_FILE_TYPE = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/svg+xml",
  "image/svg",
];

export const SCORE_TYPE = {
  IMPORTANCE: "importance",
  IMPACT: "impact",
  COST: "cost",
  EFFORT: "effort",
};

export const DEFAULT_LANG_ID = "eng";

export const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

export const indexColumnActionTable = {
  risk: 2,
  score: 1,
};

export const PREFIX_URL = ["http", "https"];

// Schedule scan
export const REPEAT_OPTIONS = [
  {
    id: "daily",
    value: "Daily",
    name: "Daily",
  },
  {
    id: "weekly",
    value: "Weekly",
    name: "Weekly",
  },
  {
    id: "monthly",
    value: "Monthly",
    name: "Monthly",
  },
  {
    id: "yearly",
    value: "Yearly",
    name: "Yearly",
  },
];

export const optionEndsSelected = {
  on: 0,
  after: 1,
  never: 2,
  unselected: "",
};

export const optionDailySelected = {
  every: 0,
  everyWeek: 1,
  unselected: "",
};

export const optionMonthlySelected = {
  day: 0,
  the: 1,
  unselected: "",
};

export const optionYearlySelected = {
  on: 0,
  onThe: 1,
  unselected: "",
};

export const REPEAT_OPTIONS_ID = {
  yearly: "yearly",
  monthly: "monthly",
  weekly: "weekly",
  daily: "daily",
};

export const byweekdayOption = [
  RRule.MO,
  RRule.TU,
  RRule.WE,
  RRule.TH,
  RRule.FR,
  RRule.SA,
  RRule.SU,
];

export const STARTS_OPTION = [
  {
    id: 1,
    name: "01 Jul 2024",
  },
];

export const AT_OPTION = [
  {
    id: 1,
    name: "10:00am",
  },
  {
    id: 2,
    name: "11:00am",
  },
];

export const ENDS_ON_OPTION = [
  {
    id: 1,
    name: "01 Jul 2024",
  },
  {
    id: 2,
    name: "04 Jul 2025",
  },
];

export const ENDS_AFTER_OPTION = [
  {
    id: 1,
    name: "1",
  },
  {
    id: 2,
    name: "2",
  },
  {
    id: 3,
    name: "3",
  },
];

export const DAY_OF_WEEK = [
  {
    id: 0,
    value: 0,
    name: "Mon",
  },
  {
    id: 1,
    value: 1,
    name: "Tues",
  },
  {
    id: 2,
    value: 2,
    name: "Wed",
  },
  {
    id: 3,
    value: 3,
    name: "Thu",
  },
  {
    id: 4,
    value: 4,
    name: "Fri",
  },
  {
    id: 5,
    value: 5,
    name: "Sat",
  },
  {
    id: 6,
    value: 6,
    name: "Sun",
  },
];

export const RISK_VALUE_MAP = {
  HIGH: 15,
  MEDIUM: 5,
  LOW: 0,
};

export const MONTH_NAMES = [
  "J",
  "F",
  "M",
  "A",
  "M",
  "J",
  "J",
  "A",
  "S",
  "O",
  "N",
  "D",
];

export const THRESH_HOLD_GET_LIST_NUMBER = 20;

export const TYPE_MODAL_SECURING_EVIDENCE = {
  DECRYPT: "DECRYPT",
  ENCRYPT: "ENCRYPT",
};

export const TYPE_ASSESSMENT_VIEW_STYLE = {
  vendor: "vendor",
  user: "user",
};

export const DRAG_AND_DROP_TABLE_TYPE = {
  ACTIONS: "actions",
  SUGGESTEDACTIONS: "suggestedActions",
  ASSESSMENTTABLE: "assessmentTable",
  VENDORTEMPLATE: "vendorTemplate",
};

export const TYPE_SCHEDULE = {
  domains: "domains",
  webservices: "webservices",
};

export const SCANNING_STATUS_TARGETS = {
  COMPLETE: "ok",
};

export const arrayDataRiskAssessmentDefault = [
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "high",
        number: 0,
      },
      {
        className: "high",
        number: 0,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "high",
        number: 0,
      },
      {
        className: "high",
        number: 0,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
    ],
  },
];

export const dummyDataRiskAssessment = [
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "high",
        number: 6,
      },
      {
        className: "high",
        number: 9,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 2,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "high",
        number: 5,
      },
      {
        className: "high",
        number: 7,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 2,
      },
      {
        className: "medium",
        number: 2,
      },
      {
        className: "medium",
        number: 4,
      },
      {
        className: "medium",
        number: 4,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 1,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
      {
        className: "medium",
        number: 0,
      },
    ],
  },
  {
    gridItem: [
      {
        className: "low",
        number: 1,
      },
      {
        className: "low",
        number: 1,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 0,
      },
      {
        className: "low",
        number: 2,
      },
    ],
  },
];
export const statusScanProgress = {
  SCAN_COMPLETE: "ok",
  SCAN_ERR: "err",
  SCAN_IN_PROGRESS: "inprog",
};

export const TYPE_ERROR_LIMIT_START_SCAN = {
  WEB_SERVICES: "exc_scan_report_run_record_exist_within_rate_limit",
  DOMAINS: "exc_scan_report_domain_run_record_exist_within_rate_limit",
  ERROR: "exc_more_webserviceids_passed_than_limited",
  ERROR_MAX_CONCURRENT: "exc_scan_report_run_exceeds_max_concurrent_limit",
  DOMAIN_FAIL: "exc_scan_report_domain_run_fail",
  WEBSERVICE_FAIL: "exc_scan_report_run_fail",
};

export const TYPE_ISSUE_OVER_TIME_OPTIONS = {
  Total: "Total",
  WebServices: "webservices",
  Domains: "domains",
};

export const TYPE_ISSUE_OVER_TIME_MINI_GRAPH_OPTIONS = {
  Total: "total",
  Critical: "critical",
  High: "high",
  Medium: "med",
  Low: "low",
};

export const COLOR_QUALITY = {
  GREEN: "#57B755",
  YELLOW: "#FE9A05",
  GREY: "#B7B7B7",
  RED: "#F7553C",
  GREY_DARK: "#878787",
};

export const SCANNING_TABLE_RESULT_ITEM_TYPE = {
  ignore: "ignore",
  include: "include",
} as const;

export const SHARING_SECTION = {
  ROAD_MAP: "Roadmap",
  NOTES: "Notes",
  INCIDENTS: "Incidents and Events",
  TRAFFIC_LIGHTS: "Traffic lights",
  PROGRESS: "noteShareProgress",
  QUICK_WINS: "Quick wins",
  ACHIEVEMENTPROGRESS: "ACHIEVEMENTPROGRESS",
};

export const QUALITY_ASSESSMENT_TYPE = {
  IMPORTANCE: "importance",
  COST: "cost",
};

export const SEARCH_TYPE_ID = {
  CL_INPUT: "clinput",
  GLOB: "glob",
  CL_RECOMM: "clrecomm",
};

export const INDEX_PRIMARY_PAGE = {
  home: 0,
  assessmentCreate: 1,
  assessmentInput: 2,
  assessmentRecommend: 3,
  cyberReport: 4,
  assessmentVendor: 5,
  scanning: 6,
  setting: 7,
};

export const RECOMMENDATION_FORCE_RESORT = {
  isForce: 1,
  isInit: 2,
};

export const RECOMMENDATION_ACTION_PcnT = {
  completion: 1,
  inProgress: 0.5,
  notStarted: 0,
  reset: null,
  isQuickWin: 2,
  nonQuickWin: 3,
};
export const VENDOR_TEMPLATE_API_STATUS = {
  isloading: "isloading",
  suceess: "suceess",
  error: "error",
  remove: "remove",
};
export const ORG_TO_ORG_TYPE_CORLOR = {
  par: {
    text: "#F7553C",
    border: "#FEE5E2",
  },
  subs: {
    text: "#01893D",
    border: "#D9EDE2",
  },
  inv: {
    text: "#F7553C",
    border: "#FEE5E2",
  },
  Investee: {
    text: "#48A0FF",
    border: "#E4F1FF",
  },
  don: {
    text: "#878787",
    border: "#EFF0F1",
  },
  ben: {
    text: "#904bd5",
    border: "rgba(144, 75, 213, 0.20)",
  },
  sp: {
    text: "#FE9A05",
    border: "rgba(254, 154, 5, 0.15)",
  },
  Customer: {
    text: "#48A0FF",
    border: "#E4F1FF",
  },
};

export const SYSTEM_ACTION_TYPE = {
  ORG_ACCESS_OFFER: "org_access_offer",
  ORG_ACCESS_REQUEST: "org_access_request",
  ORG_ACCESS_REQUEST_PROCESSED: "org_access_request_processed",
  ORG_ACCESS_OFFER_PROCESSED: "org_access_offer_processed",
  CHECKLIST_REQUESTED_SUBMIT: "checklist_requested_submit",
};

export const COMPLIANCE_TYPE = {
  ATTACH: "attach",
  YES_NO: "tf",
  TEXT: "text",
};

export const OPTION_EXPIRY_DATE_VENDOR = {
  ONE_WEEK: "1 week",
  TWO_WEEKS: "2 weeks",
  CUSTOM: "Custom",
};
